module.exports = __webpack_public_path__ + "static/media/course-promotion.362ea13d.png";